function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.25 18H13.25V15H16.25V13H13.25V10H11.25V13H8.25V15H11.25V18ZM4.25 22C3.7 22 3.22933 21.8043 2.838 21.413C2.446 21.021 2.25 20.55 2.25 20V8C2.25 7.45 2.446 6.97933 2.838 6.588C3.22933 6.196 3.7 6 4.25 6H8.25V4C8.25 3.45 8.446 2.979 8.838 2.587C9.22933 2.19567 9.7 2 10.25 2H14.25C14.8 2 15.271 2.19567 15.663 2.587C16.0543 2.979 16.25 3.45 16.25 4V6H20.25C20.8 6 21.271 6.196 21.663 6.588C22.0543 6.97933 22.25 7.45 22.25 8V20C22.25 20.55 22.0543 21.021 21.663 21.413C21.271 21.8043 20.8 22 20.25 22H4.25ZM10.25 6H14.25V4H10.25V6Z",
  fill: "#F2512D"
});

function SvgMedicalServicesReverse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalServicesReverse);
export default __webpack_public_path__ + "static/media/medical_services_reverse.00839e25.svg";
export { ForwardRef as ReactComponent };